import { combineReducers } from "redux";
import adminReducer from "./admin";
import loaderReducer from "./loader";
import ownerReducer from "./owner";
import parkingZoneReducer from "./parkingZone";
import ticketSeriesReducer from "./ticket";
import violationsReducer from "./violations";
import usersReducer from "./users";
import requestsReducer from "./requests";
import ticketCancellationRequestsReducer from "./ticketCancellationRequest";
import parkingZoneOwnershipRequestsReducer from "./parkingZoneOwnershipRequest";
import gasStationOwnershipRequestsReducer from "./gasStationOwnershipRequest";
import deleteUserRequestsReducer from "./deleteUserRequest";
import whitelistReducer from "./whitelist";
import managerReducer from "./manager";
import blacklistReducer from "./blacklist";
import gasStationReducer from "./gasStation";
import ticketFeeCancellationRequestsReducer from "./ticketFeeCancelationRequest";
import billingInfoReducer from "./billingInfo";
import viewerReducer from "./viewer";
import reportReducer from "./report"
import clientReducer from "./client"
import pzValidationRequestReducer from "./pzValidationRequest"

export default combineReducers({
  admin: adminReducer,
  parkingZone: parkingZoneReducer,
  owners: ownerReducer,
  violations: violationsReducer,
  loader: loaderReducer,
  ticketSeries: ticketSeriesReducer,
  users: usersReducer,
  requests: requestsReducer,
  ticketCancellationRequests: ticketCancellationRequestsReducer,
  parkingZoneOwnershipRequests: parkingZoneOwnershipRequestsReducer,
  deleteUserRequests: deleteUserRequestsReducer,
  whitelist: whitelistReducer,
  manager: managerReducer,
  viewer: viewerReducer,
  blacklist: blacklistReducer,
  gasStationOwnershipRequests: gasStationOwnershipRequestsReducer,
  gasStation: gasStationReducer,
  ticketFeeCancellationRequests: ticketFeeCancellationRequestsReducer,
  billingInfo: billingInfoReducer,
  report: reportReducer,
  client: clientReducer,
  pzValidationRequests: pzValidationRequestReducer,
});
